<template>
  <div
    class="full-item flex flex-direction justify-center align-center login-container min-body-height"
  >
    <el-card
      :class="
        (UI.isMobile ? 'full-item' : 'margin-bottom-100') +
          ' ' +
          (UI.clientHeight < 800 ? 'scroll-y' : '')
      "
    >
      <div slot="header" class="clearfix"><span>注册其他角色</span></div>
      <RoleEdit v-if="User.user.role"></RoleEdit>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RoleEdit from './roleEdit.vue';

export default {
  computed: {
    ...mapState(['User', 'UI']),
  },

  components: {
    RoleEdit,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/role/index.vue